/**
 * Trava dos 6 textos da noite de 25/10 propostos pelo painel editorial (ORD-F-149; PAINEL-EDITORIAL-2010.md, 20/10).
 * Cada item tem três textos no catálogo: o de antes ('today'), a proposta do painel e a alternativa mais conservadora. O
 * responsável aprovou as 6 propostas (§8 de 20/10; ORD-F-150): os 6 estão em 'proposal'. Trocar um item é trocar o
 * valor dele aqui, num commit de uma linha.
 *
 * 1. Herói na definição matemática (manchete, selo e subtítulo antes do TSE; manchete depois do TSE).
 * 2. A nota da chance quando a contagem e a chance apontam para lados diferentes.
 * 3. O alerta das cidades: rótulo "△ Atenção" e frase sem o número de votos, ou sem os alertas.
 * 4. O artigo antes do nome da cidade ("no Rio de Janeiro (RJ)"), ou a frase aberta pelo nome.
 * 5. A tendência do país: só como comentário e sem os votos projetados, ou fora do ar com a chance ligada.
 * 6. A raridade na Linha do tempo: texto novo, ou sem a etiqueta.
 *
 * As funções que escolhem o texto recebem a escolha por parâmetro, com o padrão vindo daqui (os testes exercitam as três).
 */
export type EditorialChoice = 'today' | 'proposal' | 'alternative';
export type EditorialItem = 1 | 2 | 3 | 4 | 5 | 6;

// ORD-F-150: o responsável aprovou as 6 propostas (§8 de 20/10, ~08h30)
export const EDITORIAL: Readonly<Record<EditorialItem, EditorialChoice>> = {
  1: 'proposal',
  2: 'proposal',
  3: 'proposal',
  4: 'proposal',
  5: 'proposal',
  6: 'proposal',
};
